import { BaseEntity } from "./BaseEntity";

export class POPEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "POP";
        this.pageTitle = "components.isp.pop.pageTitleList";
        this.menuPath = "/isp";
        this.APIRoute = "Resources/ISP/POP"
        this.i18nBase = "components.isp.pop";


        this.endpoints = {
            list: "/pop",
            create: "/pop",
            get: "/pop/:id",
            delete: "/pop/:id",
            activate: "/pop/:id/activate",
            deactivate: "/pop/:id/deactivate"
        };

        this.fields = [
            {
                key: "id",
                label: "user.fields.id",
                type: "text",
                visible: false,
                editable: false,
                orderBy: false
            },
            {
                key: "name",
                label: "common.labels.name",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "name"
            },
            {
                key: "description",
                label: "common.labels.description",
                type: "textarea",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "description"
            },
            {
                key: "postal_code",
                label: "common.labels.postalCode",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 2,
                maxlength: 8,
                path: "address.postal_code",
                endpoint: "viacep"
            },
            {
                key: "city",
                label: "common.labels.city",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 4,
                path: "address.city.name"
            },
            {
                key: "state",
                label: "common.labels.stateAcronym",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 1,
                maxlength: 2,
                path: "address.city.state"
            },
            {
                key: "address_line1",
                label: "common.labels.streetAddress",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 5,
                path: "address.line1"
            },

            {
                key: "neighborhood",
                label: "common.labels.neighborhood",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "address.district"
            },
            {
                key: "country",
                label: "common.labels.country",
                type: "text",
                visible: false,
                required: true,
                editable: false,
                cols: 6,
                path: "address.city.country"
            },
            {
                key: "number",
                label: "common.labels.number",
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 3,
                path: "address.line2",
                concatWith: "|"

            },
            {
                key: "complement",
                label: "common.labels.complement",
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 3,
                path: "address.line2",
                concatWith: "|"

            },
            {
                key: "address",
                label: "common.labels.landmark",
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                path: "address.detail"
            },
            {
                key: "status",
                label: null,
                type: "activeSwitch",
                visible: true,
                required: true,
                editable: true,
                orderBy: false,
                cols: 12,
                path:"status"
            },
        ]

        this.customActions = {
            duplicate: false
        }

        this.tableColumns = [
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: true
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: true
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]
        this.pages = {
            edit: {
                pageTitle: `${this.i18nBase}.pageTitleEdit`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP/${this.i18nBase}.pageTitleList`,
                route: ["/isp","/isp/pops", "/isp/pop/edit/:id"]
            },
            create: {
                pageTitle: `${this.i18nBase}.pageTitle`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP/${this.i18nBase}.pageTitleList`,
                route: ["/isp","/isp/pops", "/isp/pop/create"]
            },
            list: {
                pageTitle: `${this.i18nBase}.pageTitleList`,
                pathI18n: `components.settings.permissionManagement.menuList.ISP`,
                route: ["/isp"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: true },
                                    { label: "common.labels.inactive", value: false },
                                ],
                                path:"status"
                            }
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
